import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { IGlobalConfigurationState } from './GlobalConfigurationSliceModels'
import { setAnalyticsEventTypesThunkAction, setGlobalConfigurationThunkAction } from './middleware/GlobalConfigurationThunkActions'
import apphistory from 'common/AppHistory'
import { AppLinks } from 'enviroment/AppLinks'



export const initialGlobalConfigurationState: IGlobalConfigurationState = {
   footerConfig: {
      phoneNumber: '',
      isPhoneAvailable: false,
   },
   globalConfig: {
      sendSmsBlockingTimeInMs: 0,
      sendSmsInitialBlockingTime: 0,
      minimalLoanAmountToDisplayAdditionalFields: 0,
      mObywatelCodeValidationTimeInSeconds: 120,
      clientPeselReservedCheckBlockingTimeInSec: 0,
      clientPeselReservedCheckAvailableTryAmount: 0,
   },
   documentsLinksConfig: {
      documents: {path: '', displayedLink: '', download: false, text: ''},
      privacyPolicy: {path: '', displayedLink: '', download: false, text: ''},
      websiteRegulations: {path: '', displayedLink: '', download: false, text: ''},
      accessibilityStatement: {path: '', displayedLink: '', download: false, text: ''},
   },
   analyticsEventTypesNames: undefined,
}


export const globalConfigurationSlice = createSlice({
  name: SLICE_KEYS.GLOBAL_CONFIGURATION_SLICE,
  initialState: initialGlobalConfigurationState,
  reducers: {
      setGlobalConfiguration: (state, action: PayloadAction<IGlobalConfigurationState>) => {
         state.footerConfig = action.payload.footerConfig
         state.globalConfig = action.payload.globalConfig
         state.documentsLinksConfig = action.payload.documentsLinksConfig
      }
  },
  extraReducers(builder) {
      // Global config
      builder.addCase(setGlobalConfigurationThunkAction.fulfilled, (state, action) => {
         state.footerConfig = action.payload.footerConfig
         state.globalConfig = action.payload.globalConfig
         state.documentsLinksConfig = action.payload.documentsLinksConfig
      })
      builder.addCase(setGlobalConfigurationThunkAction.rejected, (state, action) => {
         apphistory.push(AppLinks.error) // Jeśli nie uda się pobrać globalnej konfiguracji strony, uznajemy to za błąd i kierujemy na stronę z błędem
         return
      })
      // Analytics event types names
      builder.addCase(setAnalyticsEventTypesThunkAction.fulfilled, (state, action) => {
         state.analyticsEventTypesNames = {...action.payload}
      })
      builder.addCase(setAnalyticsEventTypesThunkAction.rejected, (state, action) => {
         console.error("Nie udało się pobrać obiektu z nazwami eventów analitycznych z backendu")
      })
  }

})

// Action creators are generated for each case reducer function
export const { setGlobalConfiguration } = globalConfigurationSlice.actions

export default globalConfigurationSlice.reducer